import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M56.37 11.76C50.96 5 38.75 1 31.65 1C24.55 1 12.23 5 6.82004 11.76C-2.86996 23.87 3.74002 50.51 3.74002 50.51C3.74002 50.51 4.40004 28.93 11.67 22.55C17.86 17.11 23.54 19.2 31.6 19.2C39.66 19.2 45.34 17.12 51.53 22.55C58.8 28.94 59.46 50.51 59.46 50.51C59.46 50.51 66.06 23.87 56.37 11.76Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M13.96 5.87012C13.96 5.87012 22.55 7.19012 26.02 19.2501"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M9 10.3301C9 10.3301 13.46 10.3201 16.44 19.7401" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M5.04004 14.0802C5.04004 14.0802 9.88002 13.4202 10.83 22.8802"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M49.2401 5.87012C49.2401 5.87012 40.6501 7.19012 37.1801 19.2501"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path d="M54.2 10.3301C54.2 10.3301 49.74 10.3201 46.76 19.7401" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M58.16 14.0802C58.16 14.0802 53.32 13.4202 52.37 22.8802"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M6.48003 11.76C6.48003 11.76 0.920019 23.04 5.87002 34.77"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M56.71 11.76C56.71 11.76 62.27 23.04 57.32 34.77"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M31.6008 17.1462C31.4802 16.5217 31.3902 15.8942 31.3167 15.2622C31.1691 13.9925 31.1001 12.7218 31.1001 11.45L31.1001 11.4461C31.0902 10.1793 31.1688 8.91005 31.3167 7.63771C31.391 6.99918 31.4795 6.36663 31.6001 5.7381C31.7207 6.36663 31.8092 6.99918 31.8834 7.63771C32.0311 8.90741 32.1001 10.1781 32.1001 11.45C32.1001 12.7188 32.0214 13.99 31.8832 15.2643C31.81 15.8981 31.7205 16.525 31.6008 17.1462Z"
        fill={outline}
        stroke={outline}
      />
    </g>
  )
}
